import React, { Fragment, useState } from "react";
import { Slider } from "react-burgers";
import AppMobileMenu from "../AppMobileMenu";
import { useDispatch,useSelector } from "react-redux";

import {
  setEnableClosedSidebar,
} from "../../reducers/ThemeOptions";


  const HeaderLogo = () =>{
    const dispatch = useDispatch();
    const enableClosedSidebar = useSelector((state) => state.ThemeOptions.enableClosedSidebar);
    const [active, setActive] = useState(false)

    const toggleEnableClosedSidebar = () => {
      dispatch(setEnableClosedSidebar(!enableClosedSidebar))
     
    };

    return(
      <Fragment>
          <div className="app-header__logo">
            <div className="logo-src" />
          </div>
          <AppMobileMenu />
        </Fragment>
    )
  }

export default HeaderLogo;
